import React from 'react'
import { array } from 'react-formal-inputs'
import { Flex } from 'rebass'
import Headshot from './Headshot'

const normaliseImages = (item) => ({
  ...item,
  image:
    item.images &&
    item.images.widgets &&
    item.images.widgets[0] &&
    item.images.widgets[0].crops &&
    item.images.widgets[0].crops[0] &&
    item.images.widgets[0].crops[0].src
})

const ContentHeadshot = ({ items }) => (
  <Flex flexWrap="wrap">
    {items.map((item, index) => (
      <Headshot key={index} {...normaliseImages(item)} />
    ))}
  </Flex>
)

ContentHeadshot.defaultProps = {
  items: []
}

ContentHeadshot.propTypes = {
  items: array
}

export default ContentHeadshot
